
import { computed, defineComponent } from 'vue';
import { useRoute } from 'vue-router';

// Returns Navigate method
import { endpointNavigationComposition } from '../../../endpoint/services/endpoint-navigation.composition'

import { endpointNavigationComposition as localEndpointNavigationComposition } from '../../../../../applications/covid-hub/modules/endpoint/services/endpoint-navigation.composition';
// Return getNavigationEndpoints

    function bespokeComposition () {
		/**
		 * Endpoint
		 */
		const route = useRoute();
		const endpointId = computed((): string => {
			return route.params.endpointId as string;
		});

		return { endpointId }
	}

    export default defineComponent({
        setup() {
            return { ...bespokeComposition(), ...endpointNavigationComposition(), ...localEndpointNavigationComposition() }
        },
    })
